import React from 'react';

export default function VelkommenFooterRights() {
  return (
    <section className="py-12 bg-[#1a2e1a] text-gray-300">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-lg md:text-xl font-bold text-white mb-4" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
            Dine rettigheder som elkunde
          </h2>
          <p className="text-sm leading-relaxed mb-3">
            Det lovbestemte konkursprodukt og dets tillæg fastsættes af <a href="https://afg.forsyningstilsynet.dk/" target="_blank" rel="noopener noreferrer" className="text-[#eab308] underline">Forsyningstilsynet</a> (§ 72 f) og er ens for alle elselskaber.
            Du kan læse mere om dine rettigheder som elkunde hos Energistyrelsen og se dine egne forbrugsdata
            gratis på <a href="https://eloverblik.dk" target="_blank" rel="noopener noreferrer" className="text-[#eab308] underline">eloverblik.dk</a>.
          </p>
          <p className="text-sm leading-relaxed">
            Hvis du ønsker at klage over enkel energi, skal du først kontakte os skriftligt på{' '}
            <a href="mailto:hej@enkelenergi.dk" className="text-[#eab308] underline">hej@enkelenergi.dk</a>. Hvis vi ikke
            finder en løsning, kan du klage til Ankenævnet på Energiområdet på{' '}
            <a href="https://energianke.dk" target="_blank" rel="noopener noreferrer" className="text-[#eab308] underline">energianke.dk</a>.
          </p>
        </div>
      </div>
    </section>
  );
}